module.exports = __webpack_public_path__ + "static/img/1earth3.4b84ddd4.png";